import { useLayoutContext } from "arkh";
import { useMemo } from "react";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useSizeClass } from "../../../../../common/Utils/useSizeClass";
import { SizeClass } from "@/src/common/Utils/SizeClass";

import { PixelRatio, Platform } from "react-native";

// Få height av Header från react navigation elements
function getDefaultHeaderHeight({
  landscape,
  modalPresentation,
  topInset,
}: {
  landscape: boolean;
  modalPresentation: boolean;
  topInset: number;
}): number {
  let headerHeight;

  // On models with Dynamic Island the status bar height is smaller than the safe area top inset.
  const hasDynamicIsland = Platform.OS === "ios" && topInset > 50;
  const statusBarHeight = hasDynamicIsland
    ? topInset - (5 + 1 / PixelRatio.get())
    : topInset;

  if (Platform.OS === "ios") {
    if (Platform.isPad || Platform.isTV) {
      if (modalPresentation) {
        headerHeight = 56;
      } else {
        headerHeight = 50;
      }
    } else {
      if (modalPresentation && !landscape) {
        headerHeight = 56;
      } else {
        headerHeight = 44;
      }
    }
  } else {
    headerHeight = 64;
  }

  return headerHeight + statusBarHeight;
}

export function useWACategoryLayout() {
  const safeAreaInsets = useSafeAreaInsets();
  const space = useLayoutContext().space;
  const isCompact = useSizeClass().width === SizeClass.COMPACT;
  const headerHeight = getDefaultHeaderHeight({
    landscape: false,
    modalPresentation: true,
    topInset: 0,
  });
  return useMemo(
    () => ({
      paddingTop: space.medium + (isCompact ? 0 : headerHeight),
      paddingHorizontal: space.large,
      paddingBottom: space.xxlarge + (isCompact ? safeAreaInsets.bottom : 0),
    }),
    [
      space.medium,
      space.large,
      space.xxlarge,
      isCompact,
      headerHeight,
      safeAreaInsets.bottom,
    ]
  );
}
